<template>
  <div id="main" :class="'main-container shadow-lg bg-white '">
    <br-book-cover
      :resource_dir="readingExperience.bookData.resourceDir"
      v-if="readingExperience.currentStage === 'bookCover'"
    ></br-book-cover>
    <!-- <br-pages v-for="(chapter, index) of $store.state.bookChapters"  :key="index"
                    :resource_dir="$store.state.book.resourceDir" :chapter="chapter"></br-pages> -->
    <br-pages
      v-for="(chapter, index) of readingExperience.bookChapterList"
      :key="index"
      :resource_dir="readingExperience.bookData.resourceDir"
      :chapter="chapter"
    ></br-pages>
    <br-book-end-cover
      :resource_dir="readingExperience.bookData.resourceDir"
      v-if="readingExperience.currentStage === 'bookEndCover'"
    ></br-book-end-cover>
  </div>
</template>

<script>
import BrPages from "./BrPages";
import BrBookCover from "./BrBookCover";
import BrBookEndCover from "./BrBookEndCover";
import { mapState } from "vuex";

export default {
  name: "br-main-container",
  components: {
    BrPages,
    BrBookCover,
    BrBookEndCover,
  },
  computed: {
    ...mapState(["readingExperience"]),
  },
};
</script>

<style lang="css">
.main-container {
  margin-bottom: 1.5vh;
  margin-top: 15vh;
  border-radius: 2.5vh;
  width: 100%;
}

.bookpage {
  text-align: justify;
  padding: 5vh;
  font-size: 34px;
}
</style>
